import { createFlagsScheme, schema } from '@funtech-int/yango-shared';

export const featureFlagsScheme = createFlagsScheme({
    isPlayerDebugMode: schema.boolean.optional(false),
    filmoscopeVersion: schema.string.optional(''),
    isDynamicPrerollEnabled: schema.boolean.optional(false),
});
